import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getShiftSchedule = async ({
  companyCode,
  locationCode,
  employeeCode,
  fromDate,
  toDate,
  groupCode,
  shiftCode,
}) => {
  let queryString = "";
  if (employeeCode && employeeCode !== 0) {
    queryString += `&Employeecode=${employeeCode}`;
  }
  if (groupCode && groupCode !== 0) {
    queryString += `&Group=${groupCode}`;
  }

  if (shiftCode && shiftCode !== 0) {
    queryString += `&shift=${shiftCode}`;
  }
  
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetShiftSchedule}?companyCode=${companyCode}&LocationCode=${locationCode}&FromDate=${fromDate}&Todate=${toDate}${queryString}`
  );
  return data;
};

const shiftScheduleCreation = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.ShiftScheduleCreation,
    input
  );
  return data;
};

export const useGetShiftSheduleQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetShiftSchedule],
    queryFn: () => getShiftSchedule(input),
  });
};
export const useShiftScheduleCreationMutation = () => {
  return useMutation({
    mutationFn: shiftScheduleCreation,
  });
};
